<footer class="app-footer">
  <div class="footer-left">
    © {{ currentYear }} Busly Transportation. All rights reserved.
  </div>

  <div class="footer-right">
    <span>Version 1.0.0</span>
  </div>
</footer>
